// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"ef1a87f4","453":"bd58f8d1","467":"5c74fe44"}[chunkId] + ".chunk.js";
};